import {Component} from '@angular/core';
import {LoaderService} from "../../services/loader.service";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-loader',
  standalone: true,
  templateUrl: 'loader.component.html',
  imports: [
    MatProgressSpinnerModule,
    NgIf
  ],
  styleUrls: ['loader.component.scss']
})
export class LoaderComponent {
  constructor(public loaderService: LoaderService) {
  }
}
